import {createAsyncThunk} from '@reduxjs/toolkit';

import {AIS3_COMMENTS_REQUEST_ND_API_PREFIX} from '../model/constants';
import {IAisCommentsRequestResultTableDtoNd} from '../model/types';
import {
    fetchAisCommentsRequestRowsTableNd,
    fetchAisCommentsRequestTableNd,
    IFetchAisCommentsRequestRowsTableParams,
    IFetchAisCommentsRequestTableParams,
    IPostAisCommentsRequestData,
    postAisCommentsRequestNd,
} from './api';

export const loadAisCommentsRequestTableNd = createAsyncThunk<
    IAisCommentsRequestResultTableDtoNd[],
    IFetchAisCommentsRequestTableParams | undefined>(
        `${AIS3_COMMENTS_REQUEST_ND_API_PREFIX}/aisCommentsRequestTable`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await fetchAisCommentsRequestTableNd(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const loadAisCommentsRequestRowsTableNd = createAsyncThunk<
    IAisCommentsRequestResultTableDtoNd,
    IFetchAisCommentsRequestRowsTableParams>(
        `${AIS3_COMMENTS_REQUEST_ND_API_PREFIX}/aisCommentsRequestRowsTable`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await fetchAisCommentsRequestRowsTableNd(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const createAisCommentsRequestNd = createAsyncThunk<
    string,
    IPostAisCommentsRequestData>(
        `${AIS3_COMMENTS_REQUEST_ND_API_PREFIX}/createAisCommentsRequest`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await postAisCommentsRequestNd(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
